<template>
  <div class="worksDetails">
    <div class="worksDetails_box">
      <div class="worksDetails_box_nap">
        <p>当前位置：</p>
        <!-- <p>设计市场</p>
        <i class="el-icon-arrow-right"></i>
        <p>作品详情</p> -->
		<el-breadcrumb separator=">">
		  <el-breadcrumb-item :to="{ path: '/activeList' }">赛事活动</el-breadcrumb-item>
		  <el-breadcrumb-item >作品详情</el-breadcrumb-item>
		</el-breadcrumb>
      </div>
      <div class="box_mess"> 
        <div class="box_mess_left">
          <h3 class="">{{ info.name }}</h3>
          <p class="mess_left_mess">{{ info.summary }}</p>
          <div class="mess_left_die">
            <p class="mess_left_dieL">活动名称：{{ info.activityName }}</p>
            <p class="mess_left_dieL">赛道名称：{{ info.activityWayName }}</p>
            <p class="mess_left_dieL">作品类型：{{ info.typeName }}</p>
            <div class="mess_left_dieR">
              <p>
                <i class="iconfont">&#xe611;</i>
                <span>{{ numfix(info.viewNum) }}</span>
              </p>
              <i class="iconfontGnag"> | </i>
               <p @click="submitThumb" style="cursor: pointer;">
                <i class="iconfont iconfont2" v-if="isThumbStatus" style="color:#E6A23C">&#xe650;</i>
                <i class="iconfont iconfont2" v-else>&#xec7f;</i>
                <span>{{ numfix(info.thumbNum) }}</span>
              </p>
              <i class="iconfontGnag"> | </i>
               <p>
                <i class="iconfont">&#xe60d;</i>
                <span>{{ numfix(info.evaluateNum) }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="box_mess_right">
          <img :src="info.headUrl ?info.headUrl : require('@/assets/users.png')" alt="" />
          <div class="mess_right_btn">
            <p>{{info.nickName}}</p>
            <!-- <button @click="startChat">私信</button> -->
          </div>
        </div>
      </div>
      <div class="box_content">
        <div class="box_content_mess">
          <!-- 从数据库读取展示 -->
          <div class="ql-editor editorMess">
              <p v-html="info.description" class="vHtmlMess"></p>
          </div>
          <div class="box_contentR">
            <!-- TA的作品 -->
            <div class="box_contentRTop">
              <div class="box_contentRTitle">
                <h3>TA的作品</h3>
                <div class="box_contentRTitle_icon">
                  <i class="el-icon-arrow-left" @click="minusCurrent('minus')"></i>
                  <i class="el-icon-arrow-right" @click="minusCurrent('add')"></i>
                </div>
              </div>
              <div class="box_contentRMess" v-if="userWorksList.length>0"
                   @click="worksDetails(items.uuid)"
                   v-for="(items,index) in userWorksList" :key="index">
                <img :src="items.coverUrl" alt="" class="list_box_img">
                <h4>{{ items.name }}</h4>
                <p>{{ items.createTime }}</p>
              </div>
            </div>
            <!-- 最新活动 -->
            <div class="box_contentRTop">
              <div class="box_contentRTitle">
                <h3>最新活动</h3>
                <div></div>
              </div>
              <div class="box_contentRMess" v-for="(item,index) in activityList"
                   v-if="activityList.length>0"
                   @click="activeDetails(item.uuid)"
                   :key="index">
                <div class="box_contentRMess_imgs">
                  <img :src="item.activityLogo" alt="" />
                  <div class="activeType"
                    :class="
                    item.status == 'DRAFT' || item.status == 'PREPARE'
                      ? 'activeTypeBlue'
                      : item.status == 'COLLECT'
                      ? 'activeTypeYellow'
                      : item.status == 'EVALUATE'
                      ? 'activeTypeGreen'
                      : item.status == 'FINISHED'
                      ? ''
                      : ''
                  ">{{ item.status == 'DRAFT'||item.status == 'PREPARE'?'即将开始'
                    :item.status == 'COLLECT'?dateInfo(item,1):item.status == 'EVALUATE'?'评选中':'已结束' }}</div>
                </div>
                <h4>{{ item.activityName }}</h4>
                <span>{{ getNodeInfo(item) }}</span>
                <!--<p>{{ getDate(item.activityCollectStartTime) }}-{{ getDate(item.activityShowStartDate) }}</p>-->
              </div>
            </div>
          </div>   
        </div>
        <!-- 评价 -->
        <div class="box_button">
          <button  @click="submitVote">
            <i class="el-icon-message"></i>
            <p>投票</p>
            <p class="box_button_num">{{ info.voteNum }}</p>
          </button>
        </div>
        <div class="box_evaluate">
          <div class="box_evaluate_send">
            <el-input
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              v-model="textarea">
            </el-input>
            <div class="evaluate_send">
              <button @click="submitAssess">评论</button>
            </div>
          </div>
          <div class="evaluate_list">
            <p class="evaluate_list_title">全部评价</p>
            <div class="evaluate_list_mess" v-for="(item,index) in evaluateList"
                :key="index" v-if="evaluateList.length>0">
              <img :src="item.headUrl" alt="">
              <div class="evaluate_list_content">
                <p class="evaluate_list_content_top">
                  <span>{{ item.userName }}</span>
                  <span class="top_span">{{ item.createTime }}</span>
                </p>
                <p>{{ item.content }}</p>
              </div>
            </div>
          </div>
          <div class="evaluate_no" v-if="evaluateList.length==0">
            没有更多评论了!
          </div>
          <div style="text-align: right;padding-bottom:10px">
            <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    @prev-click="handleCurrentChange"
                    @next-click="handleCurrentChange"
                    layout="total,prev, pager, next,jumper"
                    :current-page="current"
                    :page-size="pageSize"
                    :total="total" class="pagination">
            </el-pagination>
          </div>
        </div>
        <!-- 你可能喜欢 -->
        <div class="yourLike">
          <h4 class="yourLike_title">你可能喜欢</h4>
          <div class="yourLike_box">
            <div class="yourLike_box_mess" v-for="(items,index) in tableData"
                 :key="index"
                 v-if="tableData.length>0"
                 @click="worksDetails(items.uuid)">
              <img :src="items.coverUrl" alt="" class="list_box_img" style="cursor: pointer;">
              <div class="yourLike_box_Num">
                <h3 style="cursor: pointer;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ items.name }}</h3>
                <p class="yourLike_box_p">{{ items.createTime }}</p>
                <div class="yourLike_box_icon">
                  <div class="yourLike_box_iconBox">
                    <i class="iconfont">&#xe611;</i>
                    <p>{{ numfix(items.viewNum) }}</p>
                  </div>
                  <div class="yourLike_box_iconBox">
                    <i class="iconfont iconfont_two">&#xe639;</i>
                    <p>{{ numfix(items.thumbNum) }}</p>
                  </div>
                  <div class="yourLike_box_iconBox">
                    <i class="iconfont">&#xe60d;</i>
                    <p>{{ numfix(items.evaluateNum) }}</p>
                  </div>
                </div>
                <div  class="yourLike_box_user">
                  <img :src="items.headUrl" alt="">
                  <p>{{ items.nickName }}</p>
                </div>                
              </div>
            </div>
          </div>
          <!-- <div style="text-align: right">
            <el-pagination
                    background
                    @current-change="handleCurrentChange1"
                    @prev-click="handleCurrentChange1"
                    @next-click="handleCurrentChange1"
                    layout="total,prev, pager, next,jumper"
                    :current-page="worksCurrent"
                    :page-size="worksPageSize"
                    :total="worksTotal" class="pagination">
            </el-pagination>
          </div> -->
        </div>
      </div>

    </div>
    <!--聊天窗口-->
    <chat-dialog ref="chatDialogRef"></chat-dialog>
  </div>
</template>

<script>
import chatDialog from "../../chat/chatDialog";
import { getWorksDetail, saveWorksVote, saveEvaluateList, getWorksList, getActivityList,getRandList,
  getEvaluateList, getRongCloudUser, saveThumb, isExistsThumb, deleteThumb } from '../../../utils/interface';
import { mapState, mapMutations } from "vuex";
export default {
  name: "worksDetails",
  components: {
    chatDialog
  },
  data() {
    return {
      textarea:'',
      uuid:'',
      info:{},
      evaluateList:[],
      isThumbStatus:false,
      current:1,
      total:0,
      pageSize:5,
      activityUuid:"",
      worksCurrent:1,
      worksTotal:0,
      worksPageSize:4,
      tableData:[],
      activityList:[],
      userWorksCurrent:1,
      userWorksPageSize:3,
      userWorksList:[],
      userUuid:"",
    };
  },
  created(){
    this.uuid = this.$route.params.uuid;
    this.activityUuid = this.$route.params.activityUuid;
    this.getWorksDetail();
    this.getIsExistThumb();
    this.getWorksList();
    this.getActivityList();
    this.getRandList();
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
      isLogin: "isLogin",
    }),
  },
  methods: {
    ...mapMutations(["isLoginVuex"]),
    getRandList(){
      let params = {
        status:"PASS",
        activityUuid:this.activityUuid,
        workUuid:this.uuid,
        pageSize:4
      };
      getRandList(params).then((res)=>{
        console.log(res);
        //this.tableData = res.data;
      });
    },
    getIsExistThumb(){
      if (this.isLogin){
        isExistsThumb(this.uuid).then((res)=>{
          this.isThumbStatus = res;
        });
      }
    },
    startChat() {
      let targetUserId = this.info.userUuid;
      if (this.isLogin) {
        let user = this.$store.state.isUsermessage;
        getRongCloudUser(targetUserId).then(res=> {
          if(targetUserId == user.uuid){
            this.$message({
              type: "error",
              message: "不能跟自己联系！",
            });
            return ;
          }
          this.$refs.chatDialogRef.init(user.uuid,user.name,user.headUrl,res.uuid,res.name,res.headUrl);
        });
      } else {
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    getWorksDetail(){
      getWorksDetail(this.uuid).then((res)=>{
        res.headUrl? res.headUrl : res.headUrl = require('../../../assets/users.png')
        this.info = res;
        this.userUuid = this.info.userUuid;
        this.getEvaluateList();
        this.getUserWorksList();
      });
    },
    numfix(num) {
      return num / 10000 >= 1
              ? (num / 10000).toFixed(2) + "w"
              : num / 1000 >= 1
                      ? (num / 1000).toFixed(2) + "k"
                      : num;
    },
    minusCurrent(type){
      if(type=='minus'){
        if(this.userWorksCurrent==1){
          this.$message.error("已回到首页");
          return;
        }
        this.userWorksCurrent--;
        this.getUserWorksList();
      }else if(type=='add'){
        this.userWorksCurrent++;
        this.getUserWorksList();
      }
    },
    getUserWorksList(){
      let params = {
        current:this.userWorksCurrent,
        pageSize:this.userWorksPageSize,
        userUuid:this.userUuid,
      }
      getWorksList(params).then((res)=>{
        this.userWorksList = res.list;
      });
    },
    getActivityList(){
      getActivityList({statusStr: "PREPARE,COLLECT,EVALUATE,FINISHED",current:1,pageSize:2}).then((res)=>{
        this.activityList = res.list;
      });
    },
    getEvaluateList(){
      let params = {
        worksUuid:this.info.uuid,
        current:this.current,
        pageSize:this.pageSize,
      };
      getEvaluateList(params).then((res)=>{
        this.total = res.total;
        res.list.forEach(items => {
          items.headUrl? items.headUrl : items.headUrl = require('../../../assets/users.png')
        })
        this.evaluateList = res.list;
      });
    },
    // 提交评论
    submitAssess(){
      if(this.textarea==''||this.textarea==null){
        this.$message.error("请输入评论内容");
        return;
      }
      if (this.isLogin) {
        let params = {
          worksUuid: this.info.uuid,
          content: this.textarea
        };
        saveEvaluateList(params).then((res) => {
          if (res.success) {
            this.$message.success("评论成功");
            this.getEvaluateList();
            this.textarea = ''
          }
        });
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    // 点赞
    submitThumb(){
      if (this.isLogin) {
        if (!this.isThumbStatus) {
          saveThumb(this.info.uuid).then((res) => {
            if (res.success) {
              this.info.thumbNum++;
            }
          });
        } else {
          deleteThumb(this.info.uuid).then((res) => {
            if (res.success) {
              this.info.thumbNum--;
            }
          });
        }
        this.isThumbStatus = !this.isThumbStatus;
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    // 投票
    submitVote(){
      if (this.isLogin) {
        saveWorksVote(this.info.uuid).then((res) => {
          if (res.success) {
            this.$message.success("投票成功");
            this.info.voteNum++;
          } else {
            this.$message.error(res.message);
          }
        });
      }else{
        this.$message({
          type: "success",
          message: "您需要先登录哦！",
        });
        this.$router.push('/login')
      }
    },
    // 分页
    handleCurrentChange(val){
      this.current = val;
      this.getEvaluateList();
    },
    getWorksList(){
      let params = {
        status:"PASS",
        activityUuid:this.activityUuid,
        workUuid:this.uuid
      };
      getWorksList(params).then((res)=>{
        this.worksTotal = res.total;
        res.list.forEach(items => {
          items.headUrl? items.headUrl : items.headUrl = require('../../../assets/users.png')
        })
        this.tableData = res.list;
      });
    },
    // 活动作品分页
    handleCurrentChange1(val){
      this.worksCurrent = val;
      this.getEvaluateList();
    },
    worksDetails(uuid){
      let routeData = this.$router.resolve({
        name: "worksDetails",
        params: { uuid: uuid,activityUuid:this.activityUuid },
      });
      window.open(routeData.href, "_blank");
      //this.$router.push({ name: "worksDetails", params: { uuid: uuid,activityUuid:this.activityUuid } });
    },
    // 进详情
    activeDetails(uuid){
      sessionStorage.setItem('activeDetailsNums','00');
      let routeData = this.$router.resolve({
        name: "activeDetail",
        params: { uuid: uuid }
      });
      window.open(routeData.href, "_blank");
      // this.$router.push({ name: "activeDetail", params: { uuid: uuid } });
    },
    getDate(value){
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "年" + MM + "月" + d + "日";
    },
    // 计算时间
    dateInfo(item,index){
      //date1结束时间
      //let date1 = new Date(val);
      let startDate = new Date();
      let endDate = new Date();
      if(item.nodeList.length > 0){
        for(let i=0;i<item.nodeList.length;i++){
          if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="RANGE") {
            startDate = new Date(item.nodeList[i].startDate);
            endDate = new Date(item.nodeList[i].endDate);
            break;
          }else if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="DATE"){
            startDate = new Date(item.nodeList[i].startDate);
            console.log(startDate);
            for(let k=0;k<item.nodeList.length;k++){
              if(item.nodeList[k].sort>item.nodeList[i].sort){
                endDate = new Date(item.nodeList[k].startDate);
                break;
              }
            }
            break;
          }
        }
      }
      //date2当前时间
      let date2 = new Date();
      //date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
      endDate = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
      const diff = endDate.getTime() - date2.getTime(); //目标时间减去当前时间
      if(index==1){
        if(diff>=0){
          return "距离征集结束还有"+(diff / (24 * 60 * 60 * 1000)+1)+"天";  //计算当前时间与结束时间之间相差天数
        }else{
          return "征集结束";
        }
      }
    },
    getNodeInfo(item){
      if(item.nodeList.length > 0){
        for(let i=0;i<item.nodeList.length;i++){
          if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="RANGE"){
            return this.getDate(item.nodeList[i].startDate)+"—"+this.getDate(item.nodeList[i].endDate);
            break;
          }else if(item.nodeList[i].status==="COLLECT"&&item.nodeList[i].dateType==="DATE"){
            for(let k=0;k<item.nodeList.length;k++){
              if(item.nodeList[k].sort>item.nodeList[i].sort){
                return this.getDate(item.nodeList[i].startDate)+"—"+this.getDate(item.nodeList[k].startDate);
                break;
              }
            }
            break;
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.worksDetails {
  background: rgba(249, 249, 249);
  padding-bottom: 60px;
  .worksDetails_box {
    width: 1200px;
    margin: 0 auto;
    .worksDetails_box_nap {
      font-size: 14px;
      color: #808080;
      padding: 20px 0;
      display: flex;
      align-items: center;
      i {
        margin: 0 5px;
      }
    }
    .box_mess {
      display: flex;
      align-items: center;
      margin-bottom: 10px;
      .box_mess_left {
        width: 889px;
        height: 132px;
        background: rgba(255, 255, 255);
        border-radius: 10px;  
        // flex-shrink: 0;
        margin-right: 10px;
        box-sizing: border-box;
        padding: 23px 24px 23px 22px;
        h3 {
          font-size: 18px;
          color: #414141;
        }
        .mess_left_mess {
          font-size: 12px;
          color: #7D848E;
          margin: 4px 0 20px;
          word-break:break-all;
          display:-webkit-box;
          -webkit-line-clamp:2; 
          -webkit-box-orient:vertical;
          overflow:hidden;
        }
        .mess_left_die {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .mess_left_dieL {
            font-size: 14px;
            color: #2d50a1;
            word-break: break-word;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .mess_left_dieR {
            display: flex;
            align-items: center;
            p {
              display: flex;
              align-items: center;
              font-size: 12px;
              //color: #A9AFB8;
              .iconfont {
                margin-top: 3px;
                margin-right: 2px;
              }
              .iconfont2 {
                margin-top: 0;
              }
            }
            .iconfontGnag {
              font-style: normal;
              color: #A9AFB8;
              margin: 0 15px;
              font-size: 10px;
            }
          }
        }
      }
      .box_mess_right {
        width: 300px;
        height: 132px;
        background: rgba(255, 255, 255);
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        img {
          width: 62px;
          height: 62px;
          border-radius: 50%;
          margin-right: 22px;
        }
        .mess_right_btn {
          p {
            margin-bottom: 9px;
            font-size: 18px;
            color: #414141;
          }
          button {
            width: 70px;
            height: 24px;
            border: 1px solid #2d50a1;
            border-radius: 4px;
            font-size: 12px;
            color: #2d50a1;
            background: transparent;
            cursor: pointer;
          }

        }
      }

    }
    .box_content {
      // background: rgba(255, 255, 255);
      // border-radius: 10px;
      box-sizing: border-box;
      padding-bottom: 12px;
      .editorMess {
        background: rgba(255, 255, 255);
        border-radius: 10px;
        width: 889px;
        box-sizing: border-box;
        /deep/pre {
          white-space: pre-line !important;
        }
      }
      img {
        max-width: 100%;
      }
      .box_content_mess {
        display: flex;
        border-radius: 10px;
        .box_contentR {
          width: 300px;
          flex-shrink: 0;
          margin-left: 10px;
          box-sizing: border-box;
          // padding: 10px;
          box-sizing: border-box;
          .box_contentRTop {
            background: rgba(255, 255, 255);
            border-radius: 10px;
            padding: 10px;
            &:nth-last-of-type(1){
              margin-top: 10px;
            }
            .box_contentRTitle {
              display: flex;
              align-items: center;
              justify-content: space-between;
              h3 {
                font-size: 14px;
              }
              .box_contentRTitle_icon {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #5a5a5a;
                i {
                  border-radius: 50%;
                  border: 1px solid #a7a7a7;
                  cursor: pointer;
                  &:nth-last-of-type(1){
                    margin-left: 10px;
                  }
                }
              }
            }
            .box_contentRMess {
              background: #fbfbfb;
              border-radius: 10px 10px 0 0;
              margin-top: 10px;
              margin-bottom: 14px;
              cursor: pointer;
              img {
                width: 100%;
                border-radius: 10px 10px 0 0;
                height: 135px;
              }
              h4 {
                font-size: 14px;
                margin: 0 12px 6px;
                font-weight: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                margin-top: 10px;
              }
              p {
                font-size: 12px;
                color: #7D848E;
                margin: 0 12px;
                padding-bottom: 10px;
              }
              
              .box_contentRMess_imgs {
                position: relative;
                width: 100%;
                height: 135px;
                .activeType {
                  position: absolute;
                  right: 0;
                  bottom: 0;
                  line-height: 29px;
                  text-align: center;
                  width: 162px;
                  height: 29px;
                  background-image: url('../../../assets/activelistImg/gray.jpg');
                  color: #fff;
                  font-size: 12px;
                }
                .activeTypeYellow {
                  background-image: url('../../../assets/activelistImg/yellow.jpg');
                }
                .activeTypeGreen {
                  background-image: url('../../../assets/activelistImg/green.jpg');
                }
                .activeTypeBlue {
                  background-image: url('../../../assets/activelistImg/blue.jpg');
                }
              }
            }            
          }


        }
      }
      .box_button {
        background: rgba(255, 255, 255);
        border-radius: 10px;
        margin-top: 12px;
        text-align: center;
        padding: 40px 0 20px;
        button {
          cursor: pointer;
          width: 140px;
          height: 80px;
          background: #2d50a1;
          box-shadow: 0px 3px 6px rgba(21, 126, 251, 0.3);
          border-radius: 50px;
          color: #fff;
          font-size: 12px;
          border: none;
          i {
            font-size: 18px;
          }
          .box_button_num {
            font-size: 18px;
            margin-top: 3px;
          }          
        }
      }
      .yourLike {
        margin-top: 8px;
        background: #fff;
        border-radius: 10px;
        padding: 22px 30px;
        box-sizing: border-box;
        .yourLike_title {
          font-size: 14px;
          font-weight: normal;
          margin-bottom: 10px;
          color: #5C5F5C;
        }
        .yourLike_box {
          display: flex;
          flex-wrap: wrap;
          margin-bottom: 20px;
          .yourLike_box_mess {
            width: 22%;
            background: #fbfbfb;
            border-radius: 10px;
            margin-right: 30px;
            margin-bottom: 10px;
            &:nth-last-of-type(1){
              margin-right: 0;
            }
            img {
              width: 100%;
              height: 135px;
              border-radius: 10px;
            }
            .yourLike_box_Num {
              margin: 8px 10px;
              h3 {
                font-size: 14px;
                font-weight: normal;
              }
              .yourLike_box_p {
                font-size: 12px;
                color: #999999;
                margin: 6px 0;
              }
              .yourLike_box_icon {
                display: flex;
                align-items: center;
                .yourLike_box_iconBox {
                  display: flex;
                  align-items: center;
                  margin-right: 20px;
                  color: #999;
                  i {
                    margin-right: 5px;
                  }
                  .iconfont_two {
                    margin-top: 0;
                  }
                  p {
                    font-size: 12px;
                  }
                }
              }
              .yourLike_box_user {
                margin-top: 5px;
                padding-top: 10px;
                border-top: 1px solid #efefef;
                display: flex;
                align-items: center;

                img {
                  width: 32px;
                  height: 32px;
                  border-radius: 50%;
                  margin-right: 10px;
                }
                p {
                  font-size: 14px;
                }
              }
            }            
          }


        }
      }
    }
    .box_evaluate {
      background: rgba(255, 255, 255);
      border-radius: 10px;
      margin-top: 8px;
      .box_evaluate_send {
        border-bottom: 1px solid #a9aeb785;
        padding: 10px 12px 20px;
        .evaluate_send {
          margin-top: 20px;
          text-align: right;
          button {
            width: 70px;
            height: 24px;
            border: 1px solid #ABABAB;
            border-radius: 4px;
            font-size: 12px;
            color: #ABABAB;
            background: transparent;
          }          
        }
        /deep/.el-textarea__inner {
          height: 63px;
          background: rgba(246, 246, 246);
          border-radius: 10px;
          font-size: 14px;
          border: none;
        }

      }
      .evaluate_list {
        padding: 8px 16px;
        .evaluate_list_title {
          font-size: 16px;
          color: #5C5F5C;
          margin-bottom: 14px;
        }
        .evaluate_list_mess {
          display: flex;
          padding-bottom: 18px;
          border-bottom: 1px solid #ECECEC;
          margin-bottom: 20px;
          &:nth-last-of-type(1){
            border-bottom: none;
          }
          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 20px;
          }
          .evaluate_list_content {
            font-size: 14px;
            color: #262626;
            width: 100%;
            .evaluate_list_content_top {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-bottom: 8px;
              .top_span {
                font-size: 10px;
                color: #B8B8B8;
              }
            }

          }
        }
      }
      .evaluate_no {
        font-size: 14px;
        color: #5C5F5C;
        border-top: 1px solid #ECECEC;
        text-align: center;
        height: 37px;
        line-height: 37px;

      }
    }
  }
  /deep/img { max-width: 100% }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/worksDetails.vue